try {
	require('./bootstrap');
} catch (e) {}
// jQuery should work here xD
console.log('mint-tailwind init()');

import moment from 'moment';
window.moment = moment;

// import Vue
import { createApp } from 'vue';
import router from './router';
// const Vue = require('vue');
// window.Vue = Vue;

import Root from './Root.vue';

const App = createApp({
	components: {
		Root
	}
});

App.use(router).mount('#app');


window.toggleMenu = () => {
	console.log('toggleMenu');
	// let headerWrapper = $('#header-wrapper');
	// let menuShown = headerWrapper.hasClass('menu-show');

	// if (menuShown) {
	// 	headerWrapper.removeClass('menu-show');
	// 	headerWrapper.addClass('menu-hidden');
	// } else {
	// 	headerWrapper.removeClass('menu-hidden');
	// 	headerWrapper.addClass('menu-show');
	// }
	let headerWrapper = document.querySelector("#header-wrapper");
	let menuShown = headerWrapper.classList.contains("menu-show");

	if (menuShown) {
		headerWrapper.classList.remove("menu-show");
		headerWrapper.classList.add("menu-hidden");
	} else {
		headerWrapper.classList.remove("menu-hidden");
		headerWrapper.classList.add("menu-show");
	}
};
